import { Doka360ProjectModel } from '../../../generated/efp-api'

export abstract class Doka360ProjectsDao {
  public abstract findOneById(doka360ProjectsUid: string): Promise<Doka360ProjectModel | undefined>
}
